import { render } from "./Navigation.vue?vue&type=template&id=39c6c068&scoped=true&ts=true"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"

import "./Navigation.vue?vue&type=style&index=0&id=39c6c068&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c6c068"]])

export default __exports__